import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import {
  ChildContactInfoDocsComponent
} from '@se-po/se-household-setup-feature-child-contact-info'
import {
  ChildInfoDocsComponent
} from '@se-po/se-household-setup-feature-child-info'
import { GuardianInviteDocsComponent } from '@se-po/se-household-setup-feature-guardian-invite'
import { ParentGuardianInfoDocsComponent } from '@se-po/se-household-setup-feature-parent-guardian-info'
import { ReviewDocsComponent } from '@se-po/se-household-setup-feature-review'
import { SelfInfoDocsComponent } from '@se-po/se-household-setup-feature-self-info'
import { UnsubscribeSuccessDocsComponent } from '@se-po/se-household-setup-feature-unsubscribe-success'
import { WhoDocsComponent } from '@se-po/se-household-setup-feature-whos-participating'
import { OverviewComponent } from './overview/overview.component'
import {
  SeHouseholdSetupDocsComponent
} from './se-household-setup-docs.component'

const routes: Routes = [{
  path: '',
  component: SeHouseholdSetupDocsComponent,
  children: [
    { path: '', redirectTo: 'overview', pathMatch: 'full' },
    { path: 'overview', component: OverviewComponent },
    { path: 'whos-participating', component: WhoDocsComponent },
    { path: 'child-contact-info', component: ChildContactInfoDocsComponent },
    { path: 'child-info', component: ChildInfoDocsComponent },
    { path: 'parent-guardian-info', component: ParentGuardianInfoDocsComponent },
    { path: 'guardian-invite', component: GuardianInviteDocsComponent },
    { path: 'self-info', component: SelfInfoDocsComponent },
    { path: 'review', component: ReviewDocsComponent },
    { path: 'unsubscribe-success', component: UnsubscribeSuccessDocsComponent },
    { path: '**', redirectTo: 'overview' }
  ]
}]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class SeHouseholdSetupDocsRoutingModule {}
